import { LoginProjectConfiguration } from '../../../api';
import { Action, ActionType, SecretState, SignatureTypes } from './types';

export const initialState: SecretState = {
  getDataFetching: true,
  saveDataFetching: false,
  newKeyFetching: false,
  selectedSignature: SignatureTypes.hmac,
  initialSignature: SignatureTypes.hmac,
  currHMAC: '',
  newHMAC: '',
  currRSA: null,
  newRSA: null,
  getDataError: null,
  getNewKeyError: '',
  tokenLifetime: 86400,
  initialTokenLifetime: 86400,
  tokenLifetimeError: '',
  agreeLongToken: false
};

export const signatureReducer = (state: SecretState, action: Action): SecretState => {
  switch (action.type) {
    case ActionType.getDataSuccess:
      return {
        ...state,
        getDataFetching: false,
        selectedSignature: action.payload.selectedSignature,
        initialSignature: action.payload.selectedSignature,
        currHMAC: action.payload.hmac,
        currRSA: action.payload.rsa
      };
    case ActionType.getDataFail:
      return { ...state, getDataFetching: false, getDataError: action.payload };
    case ActionType.changeSelectedSignature:
      return {
        ...state,
        selectedSignature:
          state.selectedSignature === SignatureTypes.rsa ? SignatureTypes.hmac : SignatureTypes.rsa,
        newHMAC: '',
        newRSA: null,
        getNewKeyError: ''
      };
    case ActionType.getNewHMAC:
      return {
        ...state,
        newHMAC: action.payload
      };
    case ActionType.getNewRSAStart:
      return { ...state, newKeyFetching: true, getNewKeyError: '' };
    case ActionType.getNewRSASuccess:
      return { ...state, newKeyFetching: false, newRSA: action.payload };
    case ActionType.getNewRSAFail:
      return {
        ...state,
        newKeyFetching: false,
        getNewKeyError: action.payload
      };
    case ActionType.changeTokenLifetime:
      return { ...state, tokenLifetime: action.payload };
    case ActionType.changeTokenLifetimeError:
      return { ...state, tokenLifetimeError: action.payload };
    case ActionType.submitStart:
      return { ...state, saveDataFetching: true };
    case ActionType.submitSuccess:
      return {
        ...state,
        saveDataFetching: false,
        currHMAC: state.newHMAC ? state.newHMAC : state.currHMAC,
        currRSA: state.newRSA ? state.newRSA : state.currRSA,
        initialSignature: state.selectedSignature,
        initialTokenLifetime: state.tokenLifetime,
        newHMAC: '',
        newRSA: null
      };
    case ActionType.submitFail:
      return { ...state, saveDataFetching: false };
    case ActionType.submitAgreeLongToken:
      return { ...state, agreeLongToken: action.payload };
    default:
      throw new Error('Unknown action type in Secret reducer!');
  }
};

export const init = (initProject: LoginProjectConfiguration | null): SecretState => {
  if (initProject) {
    return {
      ...initialState,
      tokenLifetime: initProject.token_expiration_time,
      initialTokenLifetime: initProject.token_expiration_time
    };
  }
  return initialState;
};
